"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionAndAnswerDto = exports.AnswerTemplateDataDto = exports.AnswerTemplateCustomerDto = exports.GetByQuestionnaireIdsDto = exports.UserAnswersDto = exports.QuestionAnswersDto = exports.QuestionDto = exports.AnswerDto = void 0;
class AnswerDto {
}
exports.AnswerDto = AnswerDto;
class QuestionDto {
}
exports.QuestionDto = QuestionDto;
class QuestionAnswersDto {
}
exports.QuestionAnswersDto = QuestionAnswersDto;
class UserAnswersDto {
}
exports.UserAnswersDto = UserAnswersDto;
class GetByQuestionnaireIdsDto {
}
exports.GetByQuestionnaireIdsDto = GetByQuestionnaireIdsDto;
class AnswerTemplateCustomerDto {
}
exports.AnswerTemplateCustomerDto = AnswerTemplateCustomerDto;
class AnswerTemplateDataDto {
}
exports.AnswerTemplateDataDto = AnswerTemplateDataDto;
class QuestionAndAnswerDto {
}
exports.QuestionAndAnswerDto = QuestionAndAnswerDto;
//# sourceMappingURL=application.dto.js.map